/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

export const ErrorType = {
  /**
   * XML parsing error.
   */
  XmlParsingError: '100',
  /**
   * Trafficking error. Media player received an Ad type that it was not expecting and/or cannot play
   */
  TrafficTypeMismatch: '200',
  /**
   * Timeout of VAST URI provided in Wrapper element, or of VAST URI provided in a subsequent
   * Wrapper element. (URI was either unavailable or reached a timeout as defined by the media player.)
   */
  ChainTimeout: '301',
  /**
   * Wrapper limit reached, as defined by the media player. Too many Wrapper responses have been
   * received with no InLine response.
   */
  WrapperDepthLoop: '302',
  /**
   * No VAST response after one or more Wrappers.
   */
  NoAds: '303',
  /**
   * Couldn't find MediaFile that is supported by this media player, based on the attributes of the
   * MediaFile element.
   */
  NotSupportedMedia: '403',
  /**
   * Ostatní chyby vyskytlé při přehrávání.
   */
  RuntimeError: '900'
};
